import { GET_MATERAILS, GET_MATERAIL_INSPECTION } from "./type";

const initalState = {
    fetchMaterialList: [],
    fetchMaterialInspetionList: []
}

const ToolkitInspectionReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_MATERAILS:
            return {
            ...state,
            fetchMaterialList: payload,
            };
        case GET_MATERAIL_INSPECTION:
            return {
              ...state,
              fetchMaterialInspetionList: payload,
            };
        default:
            return {
            ...state,
            };
    }
  };
  
  export default ToolkitInspectionReducer;